(function () {
    "use strict";

    const LIVEWIRE_TOMSELECT_HOOK = "__tomSelectLivewireHookRegistered";
    const TOM_SELECT_SELECTOR = "select.tom-select, input.tom-select";

    const patchTomSelectPasteHandling = () => {
        const TomSelectClass = globalThis.TomSelect;

        if (
            !TomSelectClass?.prototype ||
            TomSelectClass.prototype.allowPastePatchApplied
        ) {
            return;
        }

        TomSelectClass.prototype.allowPastePatchApplied = true;
        TomSelectClass.prototype.onPaste = function () {
            if (this.isLocked || !this.settings.splitOn) {
                return;
            }

            setTimeout(() => {
                const pastedText = this.inputValue();

                if (!pastedText.match(this.settings.splitOn)) {
                    return;
                }

                pastedText.trim().split(this.settings.splitOn).forEach((piece) => {
                    this.createItem(piece);
                });
            }, 0);
        };
    };

    const syncTomSelectAccessibleName = (instance) => {
        const source = instance?.input;
        const control = instance?.control_input;
        const focusNode = instance?.focus_node;
        const dropdown = instance?.dropdown_content;

        if (!source || !control) {
            return;
        }

        const ariaLabelledBy = source.getAttribute("aria-labelledby");
        const ariaLabel =
            source.getAttribute("aria-label") ||
            source.getAttribute("placeholder") ||
            source.dataset.placeholder;

        const controls = [...new Set([control, focusNode].filter(Boolean))];

        controls.forEach((element) => {
            if (ariaLabelledBy && !element.getAttribute("aria-labelledby")) {
                element.setAttribute("aria-labelledby", ariaLabelledBy);
            }

            if (
                ariaLabel &&
                !element.getAttribute("aria-label") &&
                !element.getAttribute("aria-labelledby")
            ) {
                element.setAttribute("aria-label", ariaLabel);
            }
        });

        if (!dropdown) {
            return;
        }

        if (ariaLabelledBy && !dropdown.getAttribute("aria-labelledby")) {
            dropdown.setAttribute("aria-labelledby", ariaLabelledBy);
        }

        if (
            ariaLabel &&
            !dropdown.getAttribute("aria-label") &&
            !dropdown.getAttribute("aria-labelledby")
        ) {
            dropdown.setAttribute("aria-label", ariaLabel);
        }
    };

    const getTomSelectOptions = (element) => {
        const $element = $(element);

        let options = {
            create: false,
            plugins: ["no_backspace_delete"],
            closeAfterSelect: true,
            // Fix: Hover border
            onDropdownClose: function () {
                this.control_input.blur();
            },
        };

        if ($element.data("placeholder")) {
            options.placeholder = $element.data("placeholder");
        }

        if ($element.data("countries")) {
            options.maxOptions = 300;
        }

        if ($element.attr("multiple") !== undefined) {
            options = {
                ...options,
                plugins: {
                    ...options.plugins,
                    remove_button: {
                        title: "Remove this item",
                    },
                },
                persist: false,
                create: true,
                onDelete: function (values) {
                    return confirm(
                        values.length > 1
                            ? "Are you sure you want to remove these " +
                                  values.length +
                                  " items?"
                            : 'Are you sure you want to remove "' +
                                  values[0] +
                                  '"?'
                    );
                },
            };
        }

        if ($element.data("header")) {
            options = {
                ...options,
                plugins: {
                    ...options.plugins,
                    dropdown_header: {
                        title: $element.data("header"),
                    },
                },
            };
        }

        return options;
    };

    const cleanupTomSelectMarkup = (element) => {
        element.classList.remove("tomselected", "ts-hidden-accessible");

        let sibling = element.nextElementSibling;

        while (sibling?.classList?.contains("ts-wrapper")) {
            const nextSibling = sibling.nextElementSibling;
            sibling.remove();
            sibling = nextSibling;
        }
    };

    const removeStaleTomSelectMarkup = (instance) => {
        [instance?.wrapper, instance?.dropdown].forEach((node) => {
            if (node?.remove) {
                node.remove();
            }
        });
    };

    const clearTomSelectReference = (element) => {
        if (!element || !("tomselect" in element)) {
            return;
        }

        try {
            delete element.tomselect;
        } catch (error) {
            element.tomselect = undefined;
        }
    };

    const initializeTomSelectElement = (element) => {
        if (!element?.matches?.(TOM_SELECT_SELECTOR)) {
            return null;
        }

        if (element.tomselect?.wrapper?.isConnected) {
            syncTomSelectAccessibleName(element.tomselect);
            return element.tomselect;
        }

        if (element.tomselect) {
            removeStaleTomSelectMarkup(element.tomselect);
            cleanupTomSelectMarkup(element);
        } else {
            cleanupTomSelectMarkup(element);
        }

        clearTomSelectReference(element);

        const instance = new globalThis.TomSelect(
            element,
            getTomSelectOptions(element)
        );

        syncTomSelectAccessibleName(instance);

        return instance;
    };

    const initializeTomSelects = (root = document) => {
        if (!root?.querySelectorAll) {
            return;
        }

        root.querySelectorAll(TOM_SELECT_SELECTOR).forEach((element) => {
            initializeTomSelectElement(element);
        });
    };

    const registerLivewireHooks = () => {
        if (
            globalThis[LIVEWIRE_TOMSELECT_HOOK] ||
            !globalThis.Livewire?.hook
        ) {
            return;
        }

        globalThis[LIVEWIRE_TOMSELECT_HOOK] = true;

        globalThis.Livewire.hook("message.processed", (_message, component) => {
            initializeTomSelects(component?.el ?? document);
        });
    };

    patchTomSelectPasteHandling();

    if (!globalThis.TomSelect) {
        return;
    }

    initializeTomSelects();

    if (globalThis.Livewire?.hook) {
        registerLivewireHooks();
    } else {
        document.addEventListener("livewire:load", registerLivewireHooks, {
            once: true,
        });
    }
})();
